export default __webpack_public_path__ + "static/media/notfound.0a754dbe.jpg";